module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-card', {
    attrs: {
      "product": _vm.product,
      "image": _vm.image,
      "to": {
        path: ("/erp/flexy/products/" + (_vm.product.productId))
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f352d292","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/List/Card/Flexy.vue
// module id = 3489
// module chunks = 0